import React from 'react';
import "./ShopBreadCrumb.css";
import { Link } from 'react-router-dom';


function ShopBreadCrumb(props) {
    return (
        <div className="bc__holder">
            <Link to ="/shop">ShopPage| </Link>           
            <p>{props.pagename}</p>
            
        </div>
    )
}


export default ShopBreadCrumb
